// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kN0b","productName":"Table_productName__FIP36"};